import { getFunctions, httpsCallable } from "firebase/functions";
import { auth } from "../firebase";
import { APP_ID } from "../constants/common";

export type GetRoomTokenResponse = {
  appId: string;
  channelId: string;
  token: string | null;
  rtcUid: number | string;
};

export async function fetchRoomToken(
  channelId: string,
): Promise<GetRoomTokenResponse> {
  const functions = getFunctions();
  const callable = httpsCallable(functions, "getRoomToken");
  const currentUser = auth.currentUser;
  if (!currentUser) {
    throw new Error("User not authenticated");
  }
  const result = await callable({
    channelId,
    userId: currentUser.uid,
  });
  const data = result.data as GetRoomTokenResponse;

  return {
    appId: APP_ID,
    channelId: data.channelId,
    token: data.token ?? null,
    rtcUid: currentUser.uid,
  };
}
